import { useMutation } from '@tanstack/react-query';
import { recipeCcpRequests } from '@/lib/api/requests/recipe-ccp';

/** "Got it" on a critical-control-point step: one acknowledgement row per tap. */
export function useCcpAcknowledgement() {
  return useMutation({
    mutationFn: ({
      recipeId,
      step,
      cookingSessionId,
    }: {
      recipeId: number;
      step: number;
      cookingSessionId?: number;
    }) => recipeCcpRequests.acknowledge(recipeId, step, cookingSessionId),
  });
}
